import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Box,
  Button,
  Typography,
  Container,
  Alert,
  CircularProgress,
  Stack,
  Paper,
} from '@mui/material'
import { Login, Google } from '@mui/icons-material'
import {
  selectUserIsAuthenticated,
  selectUserDisplayName,
  handleLogin,
} from '../store/slices/userSlice'

const LandingPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const isAuthenticated = useSelector(selectUserIsAuthenticated)
  const userDisplayName = useSelector(selectUserDisplayName)
  const { loading, error } = useSelector(state => state.user)

  const handleGoogleLogin = async () => {
    console.log('Google login button clicked')
    try {
      await dispatch(handleLogin(false)).unwrap()
    } catch (error) {
      console.error('Google login failed:', error)
    }
  }

  const handleTestLogin = async () => {
    console.log('Test login button clicked')
    try {
      await dispatch(handleLogin(true)).unwrap()
    } catch (error) {
      console.error('Test login failed:', error)
    }
  }

  const goToFlockManager = () => {
    navigate('/flock-manager')
  }

  // Redirect authenticated users to flock manager
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/flock-manager')
    }
  }, [isAuthenticated, navigate])

  if (isAuthenticated) {
    return (
      <Container maxWidth="sm" sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        minHeight: '60vh' 
      }}>
        <Paper elevation={3} sx={{ p: 4, borderRadius: 2, width: '100%' }}>
          <Stack alignItems="center" spacing={3}>
            <Typography variant="h3" component="h1" textAlign="center">
              Welcome back, {userDisplayName}!
            </Typography>
            <Typography variant="h6" color="text.secondary" textAlign="center">
              Ready to manage your flock?
            </Typography>
            <Button
              size="large"
              variant="contained"
              onClick={goToFlockManager}
              sx={{ px: 4 }}
            >
              Go to Flock Manager
            </Button>
          </Stack>
        </Paper>
      </Container>
    )
  }

  return (
    <Container maxWidth="sm" sx={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center', 
      minHeight: '70vh' 
    }}>
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2, width: '100%' }}>
        <Stack alignItems="center" spacing={3}>
          <Stack alignItems="center" spacing={1}>
            <Typography variant="h3" component="h1" textAlign="center">
              Origin Organizer
            </Typography>
            <Typography variant="h5" color="text.secondary" textAlign="center">
              Manage your flock with ease
            </Typography>
          </Stack>
          
          <Stack spacing={2} sx={{ width: '100%' }}>
            {error && (
              <Alert severity="error">
                {error}
              </Alert>
            )}
            
            <Button
              size="large"
              variant="contained"
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Google />}
              onClick={handleGoogleLogin}
              disabled={loading}
              fullWidth
            >
              {loading ? 'Signing in...' : 'Sign in with Google'}
            </Button>
            
            {import.meta.env.MODE === 'development' && (
              <Button
                variant="outlined"
                size="large"
                startIcon={<Login />}
                onClick={handleTestLogin}
                disabled={loading}
                fullWidth
              >
                Test Login
              </Button>
            )}
          </Stack>
        </Stack>
      </Paper>
    </Container>
  )
}

export default LandingPage